import { createStore } from '../_core/createStore';
import { lazyDependency } from '../_core/lazyDependency';
import useLeadChannelStore from '../leadChannelStore/useLeadChannelStore';
import { themeStore } from './themeStore';

const useThemeStore = createStore({
  creator: themeStore({
    useLeadChannelStore: lazyDependency(() => useLeadChannelStore),
  }),
  id: 'theme',
  middlewares: {
    devtools: true,
  },
});

export default useThemeStore;
